module.exports = __webpack_public_path__ + "static/media/pain-detect.71c66ba2.png";